import Btn from '@app/lui2/Btn';
import Luiv3Constants from '@app/lui3/constants';
import {useCallback, useState} from 'react';
import styled from 'styled-components';

import {useInboundSyncDialog} from '../../../useInboundSyncDialog';
import {useShowInboundSyncButton} from './useShowInboundSyncButton';

interface Props {
  agencyId: number;
}

const Wrapper = styled.div`
  display: flex;
  align-items: stretch;
  padding: 1rem;
  width: 100%;
  border-top: 1px solid ${Luiv3Constants.baseColor['gray-200']};
`;

const InboundSyncButton = ({agencyId}: Props) => {
  const {show} = useShowInboundSyncButton(agencyId);
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleClose = useCallback(() => {
    setDialogOpen(false);
  }, []);

  const handleOpenFailed = useCallback(() => {
    setDialogOpen(false);
  }, []);

  useInboundSyncDialog({
    enabled: dialogOpen,
    onClose: handleClose,
    onOpenFailed: handleOpenFailed,
  });

  if (!show) {
    return null;
  }

  return (
    <Wrapper>
      <Btn
        color="primary"
        variant="filled"
        fill
        onClick={() => setDialogOpen(true)}
      >
        Save in Loxo
      </Btn>
    </Wrapper>
  );
};

export default InboundSyncButton;
